import { MenuItem, Select } from "@mui/material";
import { useRef } from "react";

function SelectInputV1({ data, field }: any) {
  const selectRef = useRef<any>(null);

  return (
    <Select
      {...(field ?? {})}
      displayEmpty
      ref={selectRef}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: "200px",
            overflowY: "auto",
            width: selectRef?.current?.clientWidth
              ? `${selectRef?.current?.clientWidth}px`
              : "auto",
          },
        },
      }}
    >
      {data?.map((op: any, i: any) => (
        <MenuItem
          key={`${op.value}-${i}`}
          value={op.id}
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {op.label}
        </MenuItem>
      ))}
    </Select>
  );
}

export { SelectInputV1 };
